import { t } from "../setup/i18n-setup"

export const Themes = {
    data() {
        return {

        };
    },
    methods: {
        t,
        loadStyleSheet(style) {
            this.removeStylesByPrefix();

            if (style == 0)
                return;

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = '../css/customConfigurationStyle_' + style + '.css';

            document.head.appendChild(link);
        },
        removeStylesByPrefix() {
            const links = document.head.getElementsByTagName('link');
            const prefix = 'customConfigurationStyle_';

            for (let i = links.length - 1; i >= 0; i--) {
                const link = links[i];
                if (link.href.includes(prefix)) {
                    document.head.removeChild(link);
                }
            }
        }
    }

}